<template>
  <v-container fluid>
    <v-row class="flex-column mb-6">
      <v-col cols="12" class="mt-4">
        <v-row class="justify-center">
          <v-col cols="12" class="text-center mb-4">
            <div style="width: 200px; margin: 0 auto">
              <v-img
                width="200"
                alt="overview reinstatement icon"
                src="../assets/NextStepImageRedate.svg"
                class="text-center"
              />
            </div>
            <v-row class="mt-6">
              <v-col sm="1" md="2" lg="2"> &nbsp; </v-col>
              <v-col cols="12" sm="10" md="8" lg="8" class="font-size-16 text-left">
                <div class="font-size--16">
                  {{ $t('L_thank_you_for_providing_and_confirming') }}
                </div>
                <div class="font-size--16 mt-4">
                  {{
                    $t(
                      'L_you_will_now_complete_the_reinstatement_application_using_docusign_we_recommend_completing'
                    )
                  }}
                </div>
                <div class="font-size--16 mt-4">
                  {{ $t('L_remember_you_will_need_to_provide_the_following_information') }}
                </div>
                <div class="font-size--16 mt-4 bluetext font-weight-bold">
                  <ul>
                    <li>{{ $t('L_medical_history') }}</li>
                    <li>{{ $t('L_bank_information_routing_transite_and_account_numbers') }}</li>
                  </ul>
                </div>
                <div class="font-size--16 mt-4">
                  <span>{{
                    $t(
                      'L_if_you_have_question_or_prefer_to_recieve_a_paper_reinstament_applicatin',
                      [customerServicePhoneNum]
                    )
                  }}</span>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <!-- Button -->
        <v-row class="d-flex align-center justify-center py-4">
          <v-col cols="12" sm="6" md="4" class="pr-4">
            <OnexButton
              :disabled="disableActions"
              block
              variant="outlined"
              color="primary"
              @click="cancelAction"
            >
              {{ $t('L_cancel') }}
            </OnexButton>
          </v-col>
          <v-col cols="12" sm="6" md="4" class="pr-4">
            <OnexButton
              :disabled="disableActions"
              target="_blank"
              block
              color="primary"
              @click="continueAction"
            >
              {{ $t('L_continue') }}
            </OnexButton>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script lang="ts">
import { mapState } from 'pinia';
import { useGlobalStore } from '@/stores/global/global.store';
import { defineComponent, type ComponentOptions } from 'vue';
import { OnexButton } from '@primerica/onex-ui-lib';

const componentOptions: ComponentOptions = {
  name: 'ReinstatementProcessNextSteps',
  components: {
    OnexButton,
  },
  props: {
    disableActions: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState(useGlobalStore, {
      locale: 'locale',
    }),
    customerServicePhoneNum() {
      if (this.locale === 'en_US') {
        return '(800) 257-4725';
      } else if (this.locale === 'en_CA') {
        return '(800) 387-7876';
      } else if (this.locale === 'fr_CA') {
        return '(800) 265-4804';
      }
      return '(800) 257-4725';
    },
  },
  methods: {
    continueAction() {
      this.$emit('continueClicked');
    },
    cancelAction() {
      this.$emit('cancelClicked');
    },
  },
};
export default defineComponent(componentOptions);
</script>

<style lang="scss" scoped>
.bluetext {
  color: #063562;
}
</style>
